export default __webpack_public_path__ + "partner_239f115.png";